export default __webpack_public_path__ + "static/media/manchanda.32a53c9d.webp";